import { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import './header.css';
import Img from '../images/logo.png';
import { NAV_ITEMS } from '../pages/innerPageData';
import { getPrimaryNavPath } from '../app/routes';
import { THEME_LIGHT } from '../services/themeStorage';

function Header({ ready = true, currentRoute = '/', theme = 'dark', onToggleTheme }) {
  const headerRef = useRef(null);
  const innerRef = useRef(null);
  const brandRef = useRef(null);
  const navRef = useRef(null);
  const ctaRef = useRef(null);
  const lastScrollYRef = useRef(0);
  const tickingRef = useRef(false);
  const [isHidden, setIsHidden] = useState(false);
  const activeRoute = getPrimaryNavPath(currentRoute);
  const isLightTheme = theme === THEME_LIGHT;

  useEffect(() => {
    if (!ready) return;

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      tl.from(innerRef.current, { y: -18, opacity: 0, duration: 0.55 })
        .from(brandRef.current, { opacity: 0, x: -20, duration: 0.45 }, '-=0.3')
        .from(
          navRef.current.children,
          { opacity: 0, y: -10, duration: 0.4, stagger: 0.05 },
          '-=0.3'
        )
        .from(ctaRef.current, { opacity: 0, scale: 0.9, duration: 0.4 }, '-=0.2');
    }, headerRef);

    return () => ctx.revert();
  }, [ready]);

  useEffect(() => {
    if (!ready) return undefined;

    lastScrollYRef.current = window.scrollY;

    const updateVisibility = () => {
      const currentScrollY = window.scrollY;
      const isNearTop = currentScrollY <= 8;
      const scrollingDown = currentScrollY > lastScrollYRef.current && currentScrollY > 80;

      if (isNearTop) {
        setIsHidden(false);
      } else if (scrollingDown) {
        setIsHidden(true);
      } else if (currentScrollY < lastScrollYRef.current) {
        setIsHidden(false);
      }

      lastScrollYRef.current = currentScrollY;
      tickingRef.current = false;
    };

    const onScroll = () => {
      if (tickingRef.current) return;

      tickingRef.current = true;
      window.requestAnimationFrame(updateVisibility);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, [ready]);

  return (
    <header
      ref={headerRef}
      className={`site-header ${isHidden ? 'site-header--hidden' : ''}`}
      style={{ opacity: ready ? 1 : 0 }}
    >
      <div ref={innerRef} className="site-header__inner">
        <a ref={brandRef} className="site-header__brand" href="/">
          <img src={Img} alt="OBC Card" />
        </a>

        <nav ref={navRef} className="site-header__nav" aria-label="Primary">
          {NAV_ITEMS.map((item) => {
            const isActive = item.path === activeRoute

            return (
              <a
                key={item.path}
                href={item.path}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.label}
              </a>
            )
          })}
        </nav>

        <div ref={ctaRef} className="site-header__actions">
          {/* <button
            className="site-header__theme-toggle"
            type="button"
            aria-label={`Switch to ${isLightTheme ? 'dark' : 'light'} theme`}
            aria-pressed={isLightTheme}
            onClick={onToggleTheme}
          >
            <span>{isLightTheme ? 'Dark' : 'Light'}</span>
          </button> */}
          <a className="site-header__cta site-header__cta--ghost" href="/login">
            Sign In
          </a>
          <a className="site-header__cta" href="/register">
            Register
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
